<template>
	<div v-if="loading == false && (albums && albums.length <= 1)"></div>
	<div class="wrapper" v-else>
		<h3>{{ i18n('uploader.guest.selectAlbum')}}</h3>
		<v-progress-circular indeterminate v-if="loading" />
		<v-select v-model="album" @change="selectAlbum" :items="albums" item-value="id" item-text="name" label="Upload to album" v-else />
	</div>
</template>

<script>
import fixAlbumName from '../../PlicCanvas/js/utils/fix-album-name';
import { client } from '../../PlicCanvas/vue/utils/axios';

export default {
	props: ['extraStepProps', 'albumId'],
	data: function() {
		return {
			loading: true,
			album: this.extraStepProps?.destinationAlbumId ?? null,
			albums: []
		};
	},
	methods: {
		selectAlbum(albumId) {
			let album = this.albums.find(album => album.id === albumId);
			this.extraStepProps.changeEmbeddedTags(album);
		}
	},
	async mounted() {
		if(!this.extraStepProps?.projectId) {
			this.loading = false;
			return;
		}

		try {
			let response = await client.get('/api/v1/get-albums?projectId=' + this.extraStepProps.projectId);
			let albums = (response.data.albums ?? []).map(album => {
				fixAlbumName(album);

				return {
					id: album.id,
					name: album.name
				};
			});
			albums.sort((a, b) => a.name.localeCompare(b.name));

			this.albums = albums;
		} finally {
			this.loading = false;
		}
	}
};
</script>

<style scoped>
.wrapper {
	margin-bottom: 1em;
	max-width: 20em;
	margin-left: auto;
	margin-right: auto;
}
</style>